import Modal from './modal';

class ModalDefault {
	constructor(el) {
		this.el = el;
		this.modalContentEl =
			this.el.querySelector('.js__modal--default-content') ||
			(this.el.nextElementSibling?.classList?.contains('js__modal--default-content')
				? this.el.nextElementSibling
				: this.el.parentElement?.querySelector('.js__modal--default-content'));
		this.modalContent = this.modalContentEl ? this.modalContentEl.innerHTML : '';
		this.initializeModals();
	}

	openModal = () => {
		if (!this.modalContent) {
			return;
		}

		const ariaLabel = this.el.getAttribute('aria-label');

		Modal.show(this.modalContent, ariaLabel ? { ariaLabel } : {});
	};

	initializeModals = () => {
		if (!this.modalContent) {
			return;
		}

		this.el.addEventListener('click', this.openModal);

		// role="button" / tabindex triggers (e.g. Image Gallery figures) need Enter/Space;
		// native <button>/<a> already activate via click — skip to avoid double-open.
		this.el.addEventListener('keydown', (e) => {
			if (e.key !== 'Enter' && e.key !== ' ') {
				return;
			}

			const tag = this.el.tagName.toLowerCase();

			if (tag === 'button' || tag === 'a') {
				return;
			}

			e.preventDefault();
			this.openModal();
		});
	};
}

export default ModalDefault;
